import React from "react";
import "./Button.css";

interface ButtonProps {
  text: string;
  onClick?: (e: React.MouseEvent) => void;
    type?: "button" | "submit" | "reset";
  variant?: "addkart" | "add" | "buy" | "remove" | "checkout" | "cancel" | "edit" | "delete" | "update";
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  outline?: boolean;
  fullWidth?: boolean;
  size?: "sm" | "md" | "lg";
}

const Buttons: React.FC<ButtonProps> = ({
  text,
  onClick,
  type = "button",
  variant,
  className = "",
  disabled = false,
  loading = false,
  outline = true,
  fullWidth = false,
  size = "md"
}) => {
  const sizeClass = `button-${size}`;
  const variantClass = variant ? `button-${variant}` : "";
  const outlineClass = outline ? "button-outline" : "";
  const fullWidthClass = fullWidth ? "button-fullwidth" : "";
  const disabledClass = disabled ? "button-disabled" : "";

  return (
    <button
      type={type}
      onClick={onClick}
      className={`button-base ${sizeClass} ${variantClass} ${outlineClass} ${fullWidthClass} ${disabledClass} ${className}`}
      disabled={disabled || loading}
    >
      {loading ? "Loading..." : text}
    </button>
  );
};

export default Buttons;
